import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_PROFILING = "GET_LIST_PROFILING";
export const GET_LIST_PROFILING_ERROR = "GET_LIST_PROFILING_ERROR";
export const GET_LIST_PROFILING_SUCCESS = "GET_LIST_PROFILING_SUCCESS";

export const COUNT_PROFILING = "COUNT_PROFILING";
export const COUNT_PROFILING_SUCCESS = "COUNT_PROFILING_SUCCESS";
export const COUNT_PROFILING_ERROR = "COUNT_PROFILING_EFRROR";

export const GET_TAG = "GET_TAG";
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS";
export const GET_TAG_ERROR = "GET_TAG_ERROR";

export const GET_BIOGRAPHY = "GET_BIOGRAPHY";
export const GET_BIOGRAPHY_SUCCESS = "GET_BIOGRAPHY_SUCCESS";
export const GET_BIOGRAPHY_ERROR = "GET_BIOGRAPHY_ERROR";

export const GET_DATA_TAGS = "GET_DATA_TAGS";
export const GET_DATA_TAGS_SUCCESS = "GET_DATA_TAGS_SUCCESS";
export const GET_DATA_TAGS_ERROR = "GET_DATA_TAGS_ERROR";

export const GET_LOCATION = "GET_LOCATION";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_ERROR = "GET_LOCATION_ERROR";
/**
 * Reducer
 */

const initialState = {
  profiling: [],
  count: 0,
  error: false,
  loading: false,
  tags: [],
  dataTags: [],
  biography: [],
  location: [],
};

export const profilingReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_PROFILING:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_PROFILING_SUCCESS:
      return {
        ...state,
        loading: false,
        profiling: action.payload,
      };
    case GET_LIST_PROFILING_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count
    case COUNT_PROFILING:
      return {
        ...state,
      };

    case COUNT_PROFILING_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };

    case COUNT_PROFILING_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get tag
    case GET_TAG:
      return {
        ...state,
        loading: true,
      };
    case GET_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: action.payload,
      };
    case GET_TAG_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get biography
    case GET_BIOGRAPHY:
      return {
        ...state,
        loading: true,
      };
    case GET_BIOGRAPHY_SUCCESS:
      return {
        ...state,
        loading: false,
        biography: action.payload,
      };
    case GET_BIOGRAPHY_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get data
    case GET_DATA_TAGS:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        dataTags: action.payload,
      };
    case GET_DATA_TAGS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //get location
    case GET_LOCATION:
      return {
        ...state,
        loading: true,
      };
    case GET_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        location: action.payload,
      };
    case GET_LOCATION_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListProfiling = (limit, skip, where) => ({
  type: GET_LIST_PROFILING,
  data: {
    limit,
    skip,
    where,
  },
});

export const getTagsProfiling = () => ({
  type: GET_TAG,
});

export const getBiographyProfiling = () => ({
  type: GET_BIOGRAPHY,
});

export const getLocationProfiling = () => ({
  type: GET_LOCATION,
});

export const getDataTagsProfiling = (type, filters) => ({
  type: GET_DATA_TAGS,
  data: {
    type,
    ...filters,
  },
});

export const countListProfiling = (where) => ({
  type: COUNT_PROFILING,
  data: {
    where,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListProfiling,
      countListProfiling,
      getTagsProfiling,
      getBiographyProfiling,
      getDataTagsProfiling,
      getLocationProfiling,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListProfilingApi = (limit, skip, where) => {
  return apiCaller.getLogs("/profiling/msisdn-profile", {
    limit,
    skip,
    ...where,
  });
};

const countListProfilingApi = (where) => {
  return apiCaller.getData("/profiling/msisdn-profile/count", { ...where });
};

const getTagsProfilingApi = () => {
  return apiCaller.get("/profiling/partner-tag/get-tag");
};

const getBiographyProfilingApi = () => {
  return apiCaller.get("/profiling/partner-tag/get-biography");
};

const getLocationProfilingApi = () => {
  return apiCaller.get("/profiling/partner-tag/get-location");
};

const getDataTagsProfilingApi = (type, filters) => {
  return apiCaller.post("/profiling/partner-tag/get-data", { type, filters });
};
/**
 * sagas
 */

export const getListProfilingFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_PROFILING);
    try {
      const res = yield call(
        getListProfilingApi,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_PROFILING_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_PROFILING_ERROR, error });
    }
  }
};

export const countListProfilingFlow = function* () {
  while (true) {
    const action = yield take(COUNT_PROFILING);
    try {
      const res = yield call(countListProfilingApi, action.data.where);
      yield put({ type: COUNT_PROFILING_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_PROFILING_ERROR, error });
    }
  }
};

export const getTagProfilingFlow = function* () {
  while (true) {
    yield take(GET_TAG);
    try {
      const res = yield call(getTagsProfilingApi);
      yield put({ type: GET_TAG_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_TAG_ERROR, error });
    }
  }
};

export const getLocationProfilingFlow = function* () {
  while (true) {
    yield take(GET_LOCATION);
    try {
      const res = yield call(getLocationProfilingApi);
      yield put({ type: GET_LOCATION_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LOCATION_ERROR, error });
    }
  }
};

export const getBiographyProfilingFlow = function* () {
  while (true) {
    yield take(GET_BIOGRAPHY);
    try {
      const res = yield call(getBiographyProfilingApi);
      res.data.forEach((data) => {
        data.value = "";
      });
      yield put({ type: GET_BIOGRAPHY_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_BIOGRAPHY_ERROR, error });
    }
  }
};

export const getDataTagsProfilingFlow = function* () {
  while (true) {
    const action = yield take(GET_DATA_TAGS);
    try {
      const res = yield call(
        getDataTagsProfilingApi,
        action.data.type,
        action.data.filters
      );
      yield put({ type: GET_DATA_TAGS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_DATA_TAGS_ERROR, error });
    }
  }
};
